import { Tab, TabsWrapper } from "./styles"

export const Tabs = (props) => {
    const { tabsList, activeIdx, setActiveIdx } = props
    return (
        <TabsWrapper>
            {
                tabsList.map((tab, idx) => (
                    <Tab key={idx} active={(idx===activeIdx).toString()} onClick={() => setActiveIdx(idx)}>{tab.title}</Tab>
                ))
            }
        </TabsWrapper>
    )
}